import React from 'react'

const Intro = () => {
  return (
    <div className="w-full px-4 lg:px-0 lg:w-4/5 mx-auto py-4">
          <h1 className="font-bold text-base lg:text-[30px] text-[#1F7ED0] lg:mb-6 lg:mt-12 text-center lg:text-left">
            GIỚI THIỆU DỊCH VỤ
          </h1>
    
          <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-6">
                <div className={`p-2 lg:bg-[#D9D9D9] rounded-[10px]`} >
                  <div
                    className={`relative rounded-[10px] lg:border-2 lg:border-[#1F7ED0] py-4  h-full flex flex-col  bg-white`}
                  >
                    <div
                      className="relative overflow-hidden
      flex flex-row gap-4 py-2 items-center px-4
      bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)]"
                    >
            
                      <div
                        className="absolute top-0 right-0 h-full w-10
        bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
        [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
                      />
    
                      <h3 className="text-white text-base lg:text-[22px] font-bold text-left lg:text-center relative z-10">
                        GIỚI THIỆU VỀ MCA
                      </h3>
    
                      
                    </div>
    
                    <div className="p-4 text-sm">
                      <p className=" mb-1"><b>Giới thiệu về MCA:</b> Dịch vụ thông báo cuộc gọi nhỡ (MCA) giúp các thuê bao VinaPhone biết các thông tin những cuộc gọi nhỡ tới số thuê bao của mình trong các trường hợp điện thoại di động của thuê bao đang tắt máy, hết pin hoặc ở ngoài vùng phủ sóng.</p>
    
                      <p className="mt-2 text-sm">
                        <b>Đối tượng sử dụng dịch vụ:</b> Dịch vụ được cung cấp cho tất cả các thuê bao di động trả trước và trả sau của VinaPhone.
                      </p>
                      <p><b>Kênh cung cấp:</b> SMS, Website, Wapsite, IVR, USSD.</p>
                    </div>
    
                
                  </div>
                </div>
            <div className={`p-2 lg:bg-[#D9D9D9] rounded-[10px]`} >
                  <div
                    className={`relative rounded-[10px] lg:border-2 lg:border-[#1F7ED0] py-4  h-full flex flex-col bg-white`}
                  >
                    <div
                      className="relative overflow-hidden
      flex flex-row gap-4 py-2 items-center px-4
      bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)]"
                    >
            
                      <div
                        className="absolute top-0 right-0 h-full w-10
        bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
        [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
                      />
    
                      <h3 className="text-white text-base lg:text-[22px] font-bold text-left lg:text-center relative z-10">
                        CÁC TÍNH NĂNG CỦA DỊCH VỤ
                      </h3>
    
                      
                    </div>
    
                    <div className="p-4 text-sm">
                      <ul className="list-disc list-inside space-y-2">
                      <li>Thông báo cuộc gọi nhỡ trong 7 ngày trở về trước thời điểm bật máy, giúp thuê bao biết thông tin cuộc gọi nhỡ khi tắt máy/hết pin, ngoài vùng phủ sóng;</li>
                      <li>Nhận bản tin báo cuộc gọi nhỡ qua Email (nếu khách hàng có đăng ký);</li>
                      <li>Tính năng Thông báo trở lại mạng (Notify) cho người gọi;</li>
                      <li>Tính năng trả lời tự động;</li>
                      <li>Tính năng tra cứu cuộc gọi trong N ngày (N là 60 ngày trở lại);</li>
                      <li>Thiết lập thời gian ngừng nhận bản tin báo cuộc gọi nhỡ;</li>
                      <li>Tính năng lời nhắn thoại.</li>
                      </ul>
                    </div>
    
                
                  </div>
                </div>
          </div>
    </div>
  )
}

export default Intro
